import { render, staticRenderFns } from "./SignSOA.vue?vue&type=template&id=0d752cab&"
import script from "./SignSOA.vue?vue&type=script&lang=js&"
export * from "./SignSOA.vue?vue&type=script&lang=js&"
import style0 from "./SignSOA.vue?vue&type=style&index=0&id=0d752cab&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports